// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	let subscription_signup = [...document.querySelectorAll( "[name=subscribe]" )]
	subscription_signup.forEach( item => {
		item.classList.remove( "required" )
	} )

	let subscription_signup_mandatory = [...document.querySelectorAll( "#email-signup [name=subscribe], #form_id-4229-Are_you_agree_in_received_email_from_Ralphs" )]
	subscription_signup.forEach( item => {
		item.classList.add( "required" )
	} )
	
	$(document).ready(function () {

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

	});

	window.onload = function() {
		scrollDownAction(40, 'scroll');
		
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	if(document.querySelector('.js-open-menu')){
		document.querySelector('.js-open-menu').addEventListener('click', function(){
			document.getElementById('menu').classList.add('show');
		});

		document.querySelector('.js-open-menu').addEventListener('mouseenter',()=>{
			if(window.innerWidth > 1080){
				document.getElementById('menu').classList.add('show');
			}
		});

		document.querySelector('#menu').addEventListener('mousemove', (event)=>{
			if(window.innerWidth > 1080){
				if(event.target == event.currentTarget){
					document.getElementById('menu').classList.remove('show');
				}
			}
		})
	}
    
	if(document.querySelector('.js-close-menu')){
		document.querySelector('.js-close-menu').addEventListener('click', function(){
			document.getElementById('menu').classList.remove('show');
		});
	}

	if(document.querySelector('.js-open-menu-responsive')){
		document.querySelector('.js-open-menu-responsive').addEventListener('click', function(){
			document.getElementById('menu-responsive').classList.add('show');
			console.log('here');
		});
	}

	if(document.querySelector('.js-close-menu-responsive')){
		document.querySelector('.js-close-menu-responsive').addEventListener('click', function(){
			document.getElementById('menu-responsive').classList.remove('show');
		});
	};

	//To create after event 
    $.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
    $.datepicker._updateDatepicker = function(inst) {
    $.datepicker._updateDatepicker_original(inst);
    var afterShow = this._get(inst, 'afterShow');
    if (afterShow)
            afterShow.apply((inst.input ? inst.input[0] : null)); // trigger custom callback
    }

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}